import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail, dateFormat } from "../../lib/api";
import { AlertTriangle, Plus, Settings, ShieldCheck } from "lucide-react";

const TYP_INFO = {
  fehler: { icon: AlertTriangle, label: "Anlage-Fehler", color: "text-rose-600 bg-rose-50" },
  erweiterung: { icon: Plus, label: "Erweiterung", color: "text-falke-orange bg-orange-50" },
  garantie: { icon: ShieldCheck, label: "Garantiefall", color: "text-falke-blue bg-blue-50" },
};

export default function ServiceTickets() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ typ: "", beschreibung: "" });
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/me/service-tickets").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.typ) return setMsg("Bitte einen Typ wählen.");
    setLoading(true);
    try {
      await api.post("/me/service-tickets", form);
      setForm({ typ: "", beschreibung: "" });
      setMsg("Ticket erstellt!");
      load();
    } catch (e) {
      setMsg(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="service-tickets-page">
      <div>
        <h1 className="text-3xl font-heading font-bold text-falke-blue">Service & Support</h1>
        <p className="text-falke-anthracite/70 mt-1">Erstelle ein Ticket – wir melden uns zeitnah.</p>
      </div>

      <form onSubmit={submit} className="falke-card p-6 space-y-4" data-testid="ticket-form">
        <div>
          <div className="text-sm font-medium text-falke-blue mb-2">Ticket-Typ wählen</div>
          <div className="grid grid-cols-3 gap-3">
            {Object.entries(TYP_INFO).map(([k, info]) => {
              const Icon = info.icon;
              const active = form.typ === k;
              return (
                <button key={k} type="button" onClick={() => setForm({ ...form, typ: k })} data-testid={`ticket-typ-${k}`}
                  className={`p-4 rounded-xl border-2 text-center transition-all ${active ? "border-falke-orange bg-falke-orange/5" : "border-falke-blue/10 hover:border-falke-blue/30"}`}>
                  <div className={`w-10 h-10 mx-auto rounded-full flex items-center justify-center ${info.color}`}><Icon size={18} /></div>
                  <div className="text-sm font-semibold text-falke-blue mt-2">{info.label}</div>
                </button>
              );
            })}
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-falke-blue mb-1.5">Beschreibung *</label>
          <textarea required rows={4} value={form.beschreibung} onChange={(e) => setForm({ ...form, beschreibung: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-falke-blue/15" data-testid="ticket-beschreibung" />
        </div>
        {msg && <div className="text-sm text-falke-blue">{msg}</div>}
        <button type="submit" disabled={loading} className="btn-primary" data-testid="ticket-submit">{loading ? "Sende…" : "Ticket einreichen"}</button>
      </form>

      <div>
        <h3 className="font-heading text-lg text-falke-blue mb-3">Meine Tickets ({items.length})</h3>
        <div className="space-y-3">
          {items.map((t) => {
            const info = TYP_INFO[t.typ] || TYP_INFO.fehler;
            return (
              <div key={t.id} className="falke-card p-5 flex items-start gap-4" data-testid={`ticket-${t.id}`}>
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${info.color}`}><info.icon size={18} /></div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-falke-blue">{info.label}</div>
                  <div className="text-xs text-falke-anthracite/60">{dateFormat(t.erstellt_am)}</div>
                  <div className="text-sm mt-2">{t.beschreibung}</div>
                </div>
                <span className={`status-badge ${t.status === "erledigt" ? "bg-green-100 text-green-800" : t.status === "in_bearbeitung" ? "bg-amber-100 text-amber-800" : "bg-blue-100 text-blue-800"}`}>{t.status}</span>
              </div>
            );
          })}
          {items.length === 0 && <div className="text-sm text-falke-anthracite/60 text-center py-6">Noch keine Tickets.</div>}
        </div>
      </div>
    </div>
  );
}
